'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by lyj on 2016/8/8.
                                          */

// import { push } from 'react-router-redux';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _experienceShopList = require('redux/modules/experienceShopList');

var experienceShopListActions = _interopRequireWildcard(_experienceShopList);

var _background = require('redux/modules/background');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopList = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var location = _ref.location;

    var promises = [];
    var query = location.query;
    var filter = {};
    if (query.provinceId) {
      filter = (0, _extends3.default)({}, filter, { provinceId: query.provinceId });
    }
    if (query.cityId) {
      filter = (0, _extends3.default)({}, filter, { cityId: query.cityId });
    }
    if (query.addressId) {
      filter = (0, _extends3.default)({}, filter, { addressId: query.addressId });
    }
    promises.push(dispatch((0, _background.changeHeaderText)('共享体验')));
    promises.push(dispatch(experienceShopListActions.load(query.page, '', filter, true)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.experienceShopList.data,
    dataError: state.experienceShopList.error
  };
}, experienceShopListActions), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopList, _Component);

  function ExperienceShopList() {
    (0, _classCallCheck3.default)(this, ExperienceShopList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopList).call(this));

    _this.state = {
      page: 0,
      filter: {}
    };
    return _this;
  }

  (0, _createClass3.default)(ExperienceShopList, [{
    key: 'onAddressChange',
    value: function onAddressChange(value, level) {
      var addressInfo = this.props.addressInfo;

      if (addressInfo) {
        addressInfo({
          value: value,
          defValue: '',
          firstfilter: '',
          datafilter: ''
        }, level);
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      /*  const {dispatch, location} = this.props;
       if (dispatch) {
       dispatch(push({pathname: location.pathname, query: {...location.query, page: page}}));
       }*/
      var load = this.props.load;
      var filter = this.state.filter;

      if (load) {
        load(page, '', filter);
        this.scrollToAnchor('addressFilterBar');
        this.setState({
          page: page
        });
      }
    }
  }, {
    key: 'onAddressFilterBarClick',
    value: function onAddressFilterBarClick(data) {
      /* const {dispatch, location} = this.props;
       if (dispatch) {
       dispatch(push({pathname: location.pathname, query: {...data}}));
       } */
      // console.log(data);
      var load = this.props.load;
      var filter = this.state.filter;

      var currentFilter = (0, _extends3.default)({}, filter);
      // console.log(filter);
      if (load) {
        if (data.provinceId && data.provinceId !== '') {
          currentFilter = (0, _extends3.default)({}, currentFilter, { provinceId: data.provinceId });
        } else {
          delete currentFilter.provinceId;
        }
        if (data.cityId && data.cityId !== '') {
          currentFilter = (0, _extends3.default)({}, currentFilter, { cityId: data.cityId });
        } else {
          delete currentFilter.cityId;
        }
        if (data.addressId && data.addressId !== '') {
          currentFilter = (0, _extends3.default)({}, currentFilter, { addressId: data.addressId });
        } else {
          delete currentFilter.addressId;
        }

        this.setState({
          filter: currentFilter,
          page: 0
        });
        load('', '', currentFilter);
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch(val) {
      /*
       const {routerPush, location} = this.props;
       if (routerPush) {
       const query = {};
       if (val) {
       query.findValue = val;
       }
       routerPush({pathname: location.pathname, query: query});
       } */
      // console.log(val);
      var load = this.props.load;

      if (load) {
        load('', '', { FindValue: val });
      }
    }
  }, {
    key: 'scrollToAnchor',
    value: function scrollToAnchor(anchorName) {
      if (anchorName) {
        var anchorElement = document.getElementById(anchorName);
        if (anchorElement) {
          anchorElement.scrollIntoView();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var data = _props.data;
      var location = _props.location;

      var carouselDiv = '';
      var listContent = '';
      var currentPage = 0;
      var totalPageNumber = 1;
      var addressFilterDiv = '';
      if (data) {
        var addressData = data.addressData;
        var carouselOfExperienceShop = data.carouselOfExperienceShop;
        var carouselOfExperienceShopError = data.carouselOfExperienceShopError;
        var listOfExperienceShop = data.listOfExperienceShop;
        var listOfExperienceShopError = data.listOfExperienceShopError;
        var listOfExperienceShopRecordCount = data.listOfExperienceShopRecordCount;
        var listOfExperienceShopPagesize = data.listOfExperienceShopPagesize;

        if (carouselOfExperienceShopError) {
          carouselDiv = _react2.default.createElement(_components.ErrorLabel, { error: carouselOfExperienceShopError });
        } else if (carouselOfExperienceShop instanceof Array) {
          if (location.query && !isNaN(parseInt(location.query.page, 10))) {
            currentPage = parseInt(location.query.page, 10);
          }
          carouselDiv = _react2.default.createElement(_components.GoeasyCarousel, { page: 'productList', images: carouselOfExperienceShop });
        }
        if (listOfExperienceShopError) {
          listContent = _react2.default.createElement(_components.ErrorLabel, { error: listOfExperienceShopError });
        } else if (listOfExperienceShop instanceof Array) {
          listContent = _react2.default.createElement(
            'ul',
            { style: { width: '100%' } },
            listOfExperienceShop instanceof Array ? listOfExperienceShop.map(function (shop, index) {
              return _react2.default.createElement(_components.ExperienceShopInfo, { key: shop.id, index: index, shop: shop });
            }) : ''
          );
        }
        addressFilterDiv = _react2.default.createElement(_components.AddressFilterBar, { addressData: addressData, onAddressChange: this.onAddressChange.bind(this),
          onSearch: this.onSearch.bind(this),
          onSubmit: this.onAddressFilterBarClick.bind(this) });
        totalPageNumber = parseInt(listOfExperienceShopRecordCount / listOfExperienceShopPagesize, 10);
        if (listOfExperienceShopRecordCount % listOfExperienceShopPagesize > 0) {
          ++totalPageNumber;
        }
      }
      var middleImages = ['http://tupian.goeasy.cn:9999/yipinwang/third/yyp_bg1.png', 'http://tupian.goeasy.cn:9999/yipinwang/third/tyd.png'];
      return _react2.default.createElement(
        'div',
        null,
        carouselDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.ListPageMiddleFlip, { data: middleImages }),
        _react2.default.createElement('div', { className: 'clear' }),
        addressFilterDiv,
        _react2.default.createElement('a', { id: 'addressFilterBar' }),
        _react2.default.createElement('div', { className: 'clear' }),
        listContent,
        _react2.default.createElement('div', { className: 'clear' }),
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { selected: currentPage, totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : ''
      );
    }
  }]);
  return ExperienceShopList;
}(_react.Component), _class2.propTypes = {
  location: _react.PropTypes.object,
  dataError: _react.PropTypes.string,
  dispatch: _react.PropTypes.func,
  addressInfo: _react.PropTypes.func,
  load: _react.PropTypes.func,
  data: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ExperienceShopList;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopList/ExperienceShopList.js
 ** module id = 1470
 ** module chunks = 0
 **/